import { createAction, props } from '@ngrx/store';

export const toggleSimpleMode = createAction('[Simple Mode] Toggle Simple Mode');
export const setSimpleMode = createAction('[Simple Mode] Set Simple Mode', props<{ simpleMode: boolean }>());